module.exports = __webpack_public_path__ + "static/media/ic_union_more.a189147b.svg";